export default "__VITE_ASSET__9396eb0d__"